import { gql } from '@apollo/client';

export const GET_INTEGRATION_CONNECTIONS_FOR_TENANT = gql`
  query GetIntegrationConnectionsForTenant($tenantId: String!) {
    getIntegrationConnectionsForTenant(tenantId: $tenantId) {
      id
      integrationId
      tenantId
      integrationEnabled
    }
    getIntegrationInitializationSchema {
      integrationId
      platform
    }
  }
`;
